"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdMediaKey = void 0;
const immutable_1 = require("immutable");
const AdMediakey_1 = require("../AdMediakey");
const AdAnalyticsPlacement_1 = require("./AdAnalyticsPlacement");
class AdAnalyticsMedia {
    constructor({ key, name, placements }) {
        this.toJSON = () => ({
            key: this.key,
            name: this.name,
            placements: this.placements !== undefined ? this.placements.toJSON() : undefined,
        });
        this.key = key;
        this.name = name;
        this.placements = placements;
    }
}
AdAnalyticsMedia.fromJSON = (json) => {
    const { key, name, placements } = Object.assign({}, json);
    if (typeof name !== 'string')
        throw new Error('.name must be a string');
    if (placements !== undefined && !Array.isArray(placements))
        throw new Error('.placements must be an array');
    const _key = deserializeToAdMediaKey(key);
    const _placements = placements
        ? immutable_1.List(placements).map(placement => AdAnalyticsPlacement_1.default.fromJSON(placement))
        : undefined;
    return new AdAnalyticsMedia({
        key: _key,
        name: name,
        placements: _placements,
    });
};
const deserializeToAdMediaKey = (str) => {
    if (Object.keys(exports.AdMediaKey).indexOf(str) === -1) {
        throw new Error(`str must be a one of ${Object.keys(exports.AdMediaKey).join(', ')}`);
    }
    return str;
};
exports.AdMediaKey = {
    amazon: 'amazon',
    facebook: 'facebook',
    instagram: 'instagram',
    audience_network: 'audience_network',
    messenger: 'messenger',
    google: 'google',
    yahoo: 'yahoo',
    youtube: 'youtube',
    tiktok: 'tiktok',
};
exports.default = AdAnalyticsMedia;
